import React, { FC, HTMLAttributes, useMemo } from 'react';
import classNames from 'classnames';
import { ScreenshotPreview } from 'components';

import styles from './ScreenshotsPreview.module.scss';

export interface IScreenshotsPreview extends HTMLAttributes<HTMLDivElement> {
  name: string;
  screenshots?: string[];
  maxScreenshots?: number;
}

const ScreenshotsPreview: FC<IScreenshotsPreview> = (props) => {
  let { name, screenshots = [], maxScreenshots = 4, className } = props;
  screenshots = screenshots || [];
  const emptyItems = useMemo(
    () =>
      new Array(
        maxScreenshots - (screenshots.length > maxScreenshots ? maxScreenshots : screenshots.length)
      ).fill(0),
    [maxScreenshots, screenshots.length]
  );
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      {screenshots.map((screenshot: string) => (
        <ScreenshotPreview src={screenshot} name={name} key={screenshot} />
      ))}
      {emptyItems.map((_, idx) => (
        <ScreenshotPreview name={name} key={idx} />
      ))}
    </div>
  );
};

export default ScreenshotsPreview;
